import gql from 'graphql-tag'

export const GET_FEATURE_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
  ) {
    getFeaturePaginated(
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
      }
    ) {
      hasMore
      total
      items {
        id
        titleEn
        titleKg
        titleRu
        subtitleEn
        subtitleKg
        subtitleRu
        icon
      }
    }
  }
`

export const GET_FEATURE_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getFeature (
      data: {
        id: $id
      }
    ) {
      id
      titleEn
      titleKg
      titleRu
      subtitleRu
      subtitleKg
      subtitleEn
      icon
    }
  }
`
